import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4c6d2600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-edit-outline",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "cm-svg-bg-icon cm-svg-bg-icon--icon-copy" }
const _hoisted_5 = { class: "cm-svg-bg-icon cm-svg-bg-icon--icon-view" }
const _hoisted_6 = { class: "cm-align-center" }
const _hoisted_7 = { class: "btn-icon icon-confirm" }
const _hoisted_8 = { class: "cm-svg-bg-icon cm-svg-bg-icon--icon-confirm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["code-field-wrap", { 'is-edit': _ctx.isEdit }])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("span", { class: "code-text" }, _toDisplayString(_ctx.selfValue), 513), [
        [_vShow, _ctx.isCodeShow]
      ]),
      _withDirectives(_createVNode(_component_CmSvgIcon, {
        name: "views/dashboard/home/_components/service-info/code-field/_images/hide-dot",
        width: 56,
        height: 6,
        class: "code-field-hide-dot"
      }, null, 512), [
        [_vShow, !_ctx.isCodeShow]
      ]),
      (_ctx.editable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn-icon icon-edit",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startEdit && _ctx.startEdit(...args)))
          }, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "btn-icon icon-copy",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyText(_ctx.selfValue)))
      }, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/home/_components/service-info/code-field/_images/icon-copy",
            class: "cm-svg-bg-icon__default",
            monochrome: "",
            size: 16
          }),
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/home/_components/service-info/code-field/_images/icon-copy-hover",
            class: "cm-svg-bg-icon__hover",
            monochrome: "",
            size: 16
          })
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["btn-icon icon-view", { close: _ctx.isCodeShow }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCodeShow = !_ctx.isCodeShow))
      }, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_CmSvgIcon, {
            name: _ctx.isCodeShow
              ? 'views/dashboard/home/_components/service-info/code-field/_images/icon-view-close'
              : 'views/dashboard/home/_components/service-info/code-field/_images/icon-view-open',
            class: "cm-svg-bg-icon__default",
            monochrome: "",
            size: 16
          }, null, 8, ["name"]),
          _createVNode(_component_CmSvgIcon, {
            name: _ctx.isCodeShow
              ? 'views/dashboard/home/_components/service-info/code-field/_images/icon-view-close-hover'
              : 'views/dashboard/home/_components/service-info/code-field/_images/icon-view-open-hover',
            class: "cm-svg-bg-icon__hover",
            monochrome: "",
            size: 16
          }, null, 8, ["name"])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.isEdit]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_input, {
        size: "small",
        maxlength: "6",
        ref: "inputNode",
        modelValue: _ctx.selfValue,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selfValue) = $event)),
        onBlur: _ctx.handleBlur,
        onKeydown: _withKeys(_ctx.handleBlur, ["enter"])
      }, null, 8, ["modelValue", "onBlur", "onKeydown"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/home/_components/service-info/code-field/_images/icon-confirm",
            class: "cm-svg-bg-icon__default",
            monochrome: "",
            size: 16
          }),
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/home/_components/service-info/code-field/_images/icon-confirm-hover",
            class: "cm-svg-bg-icon__hover",
            monochrome: "",
            size: 16
          })
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isEdit]
    ])
  ], 2))
}